// hooks/usePaymentHistoryCxc.ts

import { useDispatch, useSelector } from "react-redux";

import {
  AppDispatch,
  RootState,
} from "../../../../store/store";

import useLoading
  from "../../../../hooks/useLoading";

import PaymentHistoryCxcService
  from "../services/paymentHistoryCxc.service";

import {
  clearPaymentHistory,
  setPaymentHistory,
  setPaymentHistoryError,
  setPaymentHistoryLoading,
  setSelectedReceivableId,
} from "../store/paymentHistoryCxc.slice";

export const usePaymentHistoryCxc = () => {
  const dispatch: AppDispatch = useDispatch();

  const {
    showLoadingIndicator,
    hideLoadingIndicator,
  } = useLoading();

  const {
    history,
    loading,
    error,
    selectedReceivableId,
  } = useSelector(
    (state: RootState) =>
      state.paymentHistoryCxc
  );

  /**
   * 📌 Obtener historial por ID
   */
  const fetchPaymentHistory = async (
    receivableId: number
  ) => {
    try {
      dispatch(
        setPaymentHistoryLoading(true)
      );

      dispatch(
        setSelectedReceivableId(
          receivableId
        )
      );

      showLoadingIndicator();

      const data =
        await PaymentHistoryCxcService
          .getByReceivableId(
            receivableId
          );

      dispatch(
        setPaymentHistory(data)
      );

      return data;
    } catch (err: any) {
      dispatch(
        setPaymentHistoryError(
          "Error al obtener historial de pagos"
        )
      );

      dispatch(
        clearPaymentHistory()
      );

      return null;
    } finally {
      dispatch(
        setPaymentHistoryLoading(false)
      );

      hideLoadingIndicator();
    }
  };

  /**
   * 🧹 limpieza manual
   */
  const clearHistory = () => {
    dispatch(
      clearPaymentHistory()
    );
  };

  return {
    // state
    history,
    loading,
    error,
    selectedReceivableId,

    // actions
    fetchPaymentHistory,
    clearHistory,
  };
};